export enum FieldType {
  Text = 'text',
  Textarea = 'textarea',
  Number = 'number',
  Money = 'money',
  Date = 'date',
  Select = 'select',
  MultiSelect = 'multi-select',
}
export const DefaultField = [
  '__v',
  '_id',
  'access',
  'admin',
  'agent_id',
  'avaiable_status',
  'address',
  'city_id',
  'created_at',
  'district_id',
  'email',
  'facebook',
  'gender',
  'group_id',
  'is_online',
  'name',
  'note',
  'organize_id',
  'ott_user_id',
  'password',
  'phone',
  'phonesub',
  'role',
  'rule_chat',
  'source',
  'sub_phone',
  'tags',
  'tenant_id',
  'updated_at',
  'username',
  'active',
  'avatar',
];
export enum FieldTypeContext {
  Text = 'Kiểu chữ',
  Textarea = 'Kiểu văn bản',
  Number = 'Kiểu số',
  Money = 'Kiểu tiền',
  Date = 'Kiểu ngày tháng',
  Select = 'Kiểu chọn một giá trị',
  MultiSelect = 'Kiểu chọn nhiều giá trị',
}
export class FieldConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tiêu đề',
        key: 'title',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Key thuộc tính',
        key: 'key',
        display: true,
        allowSort: false,
        classes: '',
      },
      {
        title: 'Kiểu',
        key: 'display_type',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
  static FieldTypeArray = () => {
    return [
      { id: FieldType.Text.toString(), text: FieldTypeContext.Text },
      { id: FieldType.Textarea.toString(), text: FieldTypeContext.Textarea },
      { id: FieldType.Number.toString(), text: FieldTypeContext.Number },
      // {id: FieldType.Money.toString(), text: FieldTypeContext.Money},
      { id: FieldType.Date.toString(), text: FieldTypeContext.Date },
      { id: FieldType.Select.toString(), text: FieldTypeContext.Select },
      {
        id: FieldType.MultiSelect.toString(),
        text: FieldTypeContext.MultiSelect,
      },
    ];
  };
  static FieldTypeTableString = type => {
    let html = `<small class="badge badge-default">`;
    switch (type) {
      case FieldType.Text:
        html += FieldTypeContext.Text;
        break;
      case FieldType.Textarea:
        html += FieldTypeContext.Textarea;
        break;
      case FieldType.Number:
        html += FieldTypeContext.Number;
        break;
      case FieldType.Money:
        html += FieldTypeContext.Money;
        break;
      case FieldType.Date:
        html += FieldTypeContext.Date;
        break;
      case FieldType.Select:
        html += FieldTypeContext.Select;
        break;
      case FieldType.MultiSelect:
        html += FieldTypeContext.MultiSelect;
        break;
      default:
        html += type;
    }
    return html + `</small>`;
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/properties/properties.const.ts